
import Vue, { PropType } from 'vue';
import ButtonWithDropdown from '../button-with-dropdown/ButtonWithDropdown.vue';
import Icon, { Icon as IconName } from '../icon/Icon.vue';

export default Vue.extend({
    components: {
        ButtonWithDropdown,
        Icon
    },

    props: {
        icon: {
            type: String as PropType<IconName>,
            required: true
        },
        closeOnClick: {
            type: Boolean as PropType<boolean>,
            default: false
        },
        tooltip: {
            type: String as PropType<string>,
            default: ''
        },
        ariaLabel: {
            type: String as PropType<string>,
            default: undefined
        },
        alignTooltipLeft: {
            type: Boolean as PropType<boolean>,
            default: false
        }
    }
});
